import { render, staticRenderFns } from "./MiscPart.vue?vue&type=template&id=181940b4&scoped=true&"
import script from "./MiscPart.vue?vue&type=script&lang=ts&"
export * from "./MiscPart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181940b4",
  null
  
)

export default component.exports